module.exports = "/assets/data/e9bf0f60bff374a910f76876aa4878c5-PO6.data.json";